/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import qs from 'querystring';
import { IToken } from './get-crm-token.action';


/**
 * GetCrmTokenForTefanAwaalCategory Input Action
 */

export class GetCrmTokenForTefanAwaalCategoryInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CRMTOKEN1`;
    public getCacheObjectType = () => 'CRMTOKEN1';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCrmTokenForTefanAwaalCategoryData {
    token: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCrmTokenForTefanAwaalCategoryInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
    input: GetCrmTokenForTefanAwaalCategoryInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetCrmTokenForTefanAwaalCategoryData> {
   
    const { szfCRMDomainForTefanAwwal, szfCRMClientSecretForTefanAwwal, szfCRMClientIdForTefanAwwal } = ctx.requestContext.app.config;

    const data = qs.stringify({
        client_id: szfCRMClientIdForTefanAwwal && szfCRMClientIdForTefanAwwal,
        client_secret: szfCRMClientSecretForTefanAwwal && szfCRMClientSecretForTefanAwwal,
        grant_type: 'client_credentials',
        resource: `${szfCRMDomainForTefanAwwal && szfCRMDomainForTefanAwwal}/`
    });

    const response = await Msdyn365.sendRequest<IToken>("https://login.microsoftonline.com/c03a7c9b-0691-48f2-a884-93fe49a74786/oauth2/token", "get", data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'fpc=AtsmsMTTjZxGgn3xxGhR2NIkPfoRAQAAAMaXLd0OAAAA; stsservicecookie=estsfd; x-ms-gateway-slice=estsfd'
        }
    });
    if(response && response.status===200){
        return {
            token : response.data.access_token
        };
    }else{
        return {token : ''};
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCrmTokenForTefanAwaalCategoryData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCrmTokenForTefanAwaalCategory',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
